import React from 'react';
import { useHistory, useLocation } from "react-router-dom";
import ConfirmMailContent from './ConfirmMailContent';

const ConfirmMail = () => {
  const history = useHistory();

  const search = useLocation().search;
  const confirmType = new URLSearchParams(search).get('type');
  const email = new URLSearchParams(search).get('email');

  if(!confirmType){
    return history.goBack();
  }

  const getTextByType = () => {

    if(confirmType === 'forgot'){
      return 'Haga clic en el enlace incluido para restablecer su contraseña.'
    }else if(confirmType === 'confirm'){
      return 'Haga clic en el enlace incluido para confirmar su correo electrónico.'
    }

    return '';
  }

  return  <div className="text-center">
            <ConfirmMailContent email={email} alterText={getTextByType()} />
          </div>
}

export default ConfirmMail;
